import { contentBase as contentBaseSchema } from './content';
import { z } from 'zod';
import { metadata } from './helpers';

export const injuryContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    title: z.string(),
    content: z.string(),
    picture: z.string(),
  }),
});

export const contentTypeInjuryContentSchema = contentBaseSchema.extend({
  content: injuryContentSchema,
});

export type ContentTypeInjuryContentInput = z.infer<typeof contentTypeInjuryContentSchema>;
